import { UsageModel } from '@bymason/controller-api-hooks';
import {
  ControllerDataGrid,
  GridColDef,
  GridDensity,
  GridRowsProp,
} from '@bymason-private/legacy-pattern-components';
import { dataGridDataSizeFormatter, dataGridDateFormatter } from '@bymason-private/pattern-components';

const gridColumns: GridColDef[] = [
  {
    field: 'date',
    headerName: 'Date',
    valueFormatter: dataGridDateFormatter,
    width: 120,
  },
  {
    field: 'download',
    headerName: 'Download',
    type: 'number',
    valueFormatter: dataGridDataSizeFormatter,
    width: 160,
  },
  {
    field: 'upload',
    headerName: 'Upload',
    type: 'number',
    valueFormatter: dataGridDataSizeFormatter,
    width: 160,
  },
  {
    field: 'total',
    headerName: 'Total',
    type: 'number',
    valueFormatter: dataGridDataSizeFormatter,
    width: 160,
  },
];

interface ByDayGridProps {
  density: GridDensity;
  show: boolean;
  usageByDay: void | UsageModel[];
}

export default function ByDayGrid({ density, show, usageByDay }: ByDayGridProps) {
  const gridRows: GridRowsProp = usageByDay
    ? usageByDay.map((record) => ({
        id: record.day.toLocaleString(),
        date: record.day,
        download: record.download,
        upload: record.upload,
        total: record.total,
      }))
    : [];

  return show ? (
    <ControllerDataGrid
      columns={gridColumns}
      density={density}
      disableSelectionOnClick
      loading={!usageByDay}
      rows={gridRows}
    />
  ) : null;
}
